module.exports = __webpack_public_path__ + "media/images/pokerroom/redstar/step4-full-dc0ddba2ccb04c47941adf16f2b69ef1.jpg";